import React, {createContext, useContext, useEffect, useState, useMemo } from "react"
import { useLocation } from '@reach/router';
import { ChildAPIContext } from './childapi'
import { UserContext } from "./usermanagement"
import { extractPageLocation } from "./utilityFunctions";

export const AnalyticContext = createContext(null);

const AnalyticComponent = ({children, pageTitle}) => {
	const location = useLocation();
	const [analyticState, setAnalyticState] = useState();
	const value = useMemo(() => [analyticState, setAnalyticState], [analyticState]);

	const childAPIData = useContext(ChildAPIContext)
	const userStateData = useContext(UserContext)

	let rollType="anonymous"
	let loginStatus="logged-out"
	let userId="anonymous"
	let userType;

	if(childAPIData?.childAPI && childAPIData?.childAPI[0]?.auth_token) {
		rollType="Kid"
		userType="kids"
		loginStatus="logged-in"
		userId=childAPIData.childAPI[0].child
	} else if(userStateData && userStateData[0] && userStateData[0]?.cognito_user?.username) {
		rollType="Grown-Up"
		userType="parent"
		loginStatus="logged-in"
		userId=userStateData[0].cognito_user.username
	}

	useEffect(() => {
		const globalEvent = {
				event: 'pageview',
				rollType: rollType,
				pageName: pageTitle,
				loginStatus: loginStatus, 
				userID: userId,
				pagePath: location.pathname
			}
			// console.log(JSON.stringify(globalEvent,null,2))
			pushDataLayer(globalEvent);
	}, [])


	const pushDataLayer = (analyticsEvent, inPageLocation) => {

		if(analyticsEvent) {

			try {
				if (typeof analyticsEvent === 'string') {
					analyticsEvent = JSON.parse(analyticsEvent)
					analyticsEvent = {...analyticsEvent, inPageLocation};
				}

				window.dataLayer.push(analyticsEvent);
			} catch(e) {
				console.error("Error pushing to analytics", e);
			}   
		}
	}


	
	
	
	const analyticClick = (e) => {
		if (typeof window !== "undefined" && typeof window.dataLayer !== 'undefined' && Array.isArray(window.dataLayer)) {
			let item = e.target;
			let analytics = (item.dataset?.analytics)?(item.dataset.analytics):(item.parentElement.dataset.analytics);
			let inPageLocation = extractPageLocation(item);
			
			if (analytics) {
				pushDataLayer(analytics, inPageLocation);
			}

			//AllEpisodeCards slider arrows

			if(typeof(e.target.className)  === 'string' && e.target.className.indexOf('slick-arrow') > -1) {
				let parent = userType === "parent";
				let eventName = parent ? "episode_arrow" : "poster_arrow";
				let analytics = `{"event": "${eventName}", "loginStatus": "logged-in", "actionType": "Button Click", "moduleName": "${parent ? "Grown-up Dashboard - Engagement" : "Child Dashboard - Engagement"}", "pageName": "${pageTitle}", "userType": "${userType}"}`;
				pushDataLayer(analytics, inPageLocation);
			}     
		}
	}


  	return(
		<AnalyticContext.Provider value={value}>
			<div className="analyticClickHandler" onClick={analyticClick} >
				{children}
			</div>
		</AnalyticContext.Provider>
  	)
}

// Wrapper component
const Analytic = ({children, pageTitle}) => {
  return(
      <AnalyticComponent pageTitle={pageTitle}>
        {children}
      </AnalyticComponent>
  )
}

export default Analytic
